import { render } from "./DocumentContainer.vue?vue&type=template&id=51a5b88c&scoped=true"
import script from "./DocumentContainer.vue?vue&type=script&lang=js"
export * from "./DocumentContainer.vue?vue&type=script&lang=js"

import "./DocumentContainer.vue?vue&type=style&index=0&id=51a5b88c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a5b88c"]])

export default __exports__